var y = Object.defineProperty;
var k = (e, n, a) => n in e ? y(e, n, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[n] = a;
var t = (e, n, a) => k(e, typeof n != "symbol" ? n + "" : n, a);
function Et() {
  var e;
  try {
    return typeof ((e = window == null ? void 0 : window.mixpanel) == null ? void 0 : e.get_distinct_id) == "function" ? window.mixpanel.get_distinct_id() : void 0;
  } catch (n) {
    console.error(n);
    return;
  }
}
function w() {
  var e, n;
  return typeof window < "u" && ((n = (e = window.location) == null ? void 0 : e.hostname) == null ? void 0 : n.indexOf("hs-app.local.hsenv.io")) >= 0;
}
function b() {
  return typeof window < "u" && !!window.__STORYBOOK_API__;
}
function h(e) {
  var n;
  return w() ? `${e}${((n = window.hsGlobal) == null ? void 0 : n.mixpanelSuffix) ?? ""}` : e;
}
const T = {
  identify: (e) => {
    console.log("@helpscout/analytics identify:", e);
  },
  reset: () => {
    console.log("@helpscout/analytics reset");
  },
  track: (e, n) => {
    console.log("@helpscout/analytics track:", e, n);
  }
}, I = {
  identify: () => {
  },
  reset: () => {
  },
  track: () => {
  }
};
function c() {
  var e;
  return typeof window < "u" && typeof ((e = window.mixpanel) == null ? void 0 : e.track) == "function" ? window.mixpanel : P();
}
function P() {
  return w() || b() ? T : I;
}
const R = 3e3, O = 50, _ = 500, M = 6, D = 1e3, V = "hs-mixpanel-flag-overrides", m = "hs-mixpanel-flag-cache", l = /* @__PURE__ */ new Map();
F();
let r = null;
function S(e) {
  if (typeof window > "u") return null;
  try {
    const n = window.localStorage.getItem(V);
    if (!n) return null;
    const a = JSON.parse(n), o = a == null ? void 0 : a[e];
    return typeof o == "boolean" || typeof o == "string" ? o : null;
  } catch {
    return null;
  }
}
function F() {
  if (!(typeof window > "u"))
    try {
      const e = window.sessionStorage.getItem(m);
      if (!e) return;
      const n = JSON.parse(e);
      for (const [a, o] of Object.entries(n))
        (typeof o == "boolean" || typeof o == "string") && l.set(a, o);
    } catch {
    }
}
function B(e, n) {
  if (!(typeof window > "u"))
    try {
      const a = window.sessionStorage.getItem(m), o = a ? JSON.parse(a) : {};
      o[e] = n, window.sessionStorage.setItem(m, JSON.stringify(o));
    } catch {
    }
}
async function U(e = R) {
  var a, o, i;
  if (typeof window > "u") return !1;
  const n = Date.now();
  for (; typeof ((o = (a = window.mixpanel) == null ? void 0 : a.flags) == null ? void 0 : o.get_variant_value) != "function"; ) {
    const d = Date.now() - n;
    if (typeof ((i = window.mixpanel) == null ? void 0 : i.track) != "function" && d >= _ || d >= e) return !1;
    await new Promise((x) => setTimeout(x, O));
  }
  return !0;
}
function G() {
  return r || (r = U().then((e) => (e || (r = null), e))), r;
}
async function L(e) {
  const a = await c().flags.get_variant_value(e, !1), o = typeof a == "boolean" || typeof a == "string" ? a : !1;
  return l.set(e, o), B(e, o), o;
}
async function A(e, n = 0) {
  var a;
  for (let o = 0; ; o++) {
    if (await G() && typeof ((a = c().flags) == null ? void 0 : a.get_variant_value) == "function")
      try {
        return await L(e);
      } catch (d) {
        return console.error(d), !1;
      }
    if (o >= n) return !1;
    await new Promise((i) => setTimeout(i, D));
  }
}
async function wt(e) {
  await Promise.all(
    e.filter((n) => !l.has(n)).map((n) => A(n, M))
  );
}
function St(e) {
  const n = W(e);
  return n === void 0 ? void 0 : n === !0;
}
function W(e) {
  const n = S(e);
  return n !== null ? n : l.get(e);
}
async function At(e) {
  const n = S(e);
  return n !== null ? n === !0 : l.has(e) ? l.get(e) === !0 : await A(e) === !0;
}
const N = "user_";
function gt(e) {
  var n, a;
  if (!e) {
    console.error(
      "@helpscout/analytics: Cannot identify user for MixPanel without a user ID"
    );
    return;
  }
  try {
    (a = (n = c()).identify) == null || a.call(
      n,
      h(`${N}${e}`)
    );
  } catch (o) {
    console.error(
      "@helpscout/analytics: Error identifying user for MixPanel",
      o
    );
  }
}
function ft() {
  var e, n;
  try {
    (n = (e = c()).reset) == null || n.call(e);
  } catch (a) {
    console.error(
      "@helpscout/analytics: Error resetting identity for MixPanel",
      a
    );
  }
}
const K = [
  "Clicked Button",
  "Clicked Copy Workflow Button",
  "Clicked Copy Workflow to Mailbox Button",
  "Clicked Link",
  'In App Tour "Next" Button Clicked',
  'In App Tour "Close" Button Clicked',
  "Signed Up"
];
class s {
  /**
   * Constructor for BaseEvent
   * @param properties - Properties for the event
   */
  constructor(n) {
    /** Event properties */
    t(this, "properties");
    this.properties = n;
  }
  /**
   * Get trackable properties. This is the properties that will be sent to the
   * tracking service. The default implementation adds the following properties:
   * - `companyId` - The company ID
   * - `memberId` - The member ID
   * - `userId` - The user ID
   * Override this method to add additional properties.
   * @protected
   */
  getTrackableProperties() {
    return {
      ...this.properties ?? {},
      companyId: window.hsGlobal.companyId,
      memberId: K.includes(this.name) ? window.hsGlobal.memberId : void 0,
      userId: window.hsGlobal.memberId
    };
  }
  /**
   * Get the track function. This is the function that will be used to track the
   * event. The default implementation checks if the environment is a storybook
   * environment or a local environment. If it is a storybook environment, it
   * returns the console track function. If it is a local environment, it returns
   * the console track function. Otherwise, it returns the noop track function.
   * Override this method if you want to use a different tracking service or
   * strategy.
   * @protected
   */
  getAnalyticsService() {
    return c();
  }
  /**
   * Track the event. This is the function that will be called to track the event.
   * The default implementation adds the following properties to the trackable
   * properties:
   * - `companyId` - The company ID
   * - `memberId` - The member ID
   * - `userId` - The user ID
   *
   * @returns The current instance of the event
   */
  track() {
    try {
      const n = this.getTrackableProperties();
      this.getAnalyticsService().track(this.name, n);
    } catch (n) {
      console.error("@helpscout/analytics track failed", n);
    }
    return this;
  }
}
class Y extends s {
  constructor({
    pageVisited: a,
    state: o
  }) {
    super({
      pageVisited: a ?? (typeof window < "u" ? window.location.pathname : "/"),
      ...o && { state: o }
    });
    t(this, "name", "pageVisited");
  }
}
class p extends s {
}
class $ extends p {
  constructor() {
    super(...arguments);
    t(this, "name", "Clicked Button");
  }
}
class H extends p {
  constructor() {
    super(...arguments);
    t(this, "name", "Clicked Link");
  }
}
class j extends p {
  constructor({
    step: a
  }) {
    var o, i;
    super({
      signUpStep: a,
      com_id: ((o = window.hsGlobal) == null ? void 0 : o.companyId) ?? "",
      usr_id: ((i = window.hsGlobal) == null ? void 0 : i.memberId) ?? ""
    });
    t(this, "name", "Signed Up");
  }
}
class J extends s {
  constructor(a) {
    super({
      currentAvailabilityStatus: a == null ? void 0 : a.currentAvailabilityStatus
    });
    t(this, "name", "accountDropdownOpened");
  }
}
class z extends s {
  constructor(a) {
    super({
      itemType: a.itemType,
      itemValue: a.itemValue
    });
    t(this, "name", "accountDropdownItemClicked");
  }
}
class X extends s {
  constructor(a) {
    super({
      currentStatus: a.currentStatus,
      intendedStatus: a.intendedStatus
    });
    t(this, "name", "availabilityToggleClicked");
  }
}
class q extends s {
  constructor(a) {
    super({
      previousStatus: a.previousStatus,
      newStatus: a.newStatus,
      success: a.success,
      errorType: a.errorType
    });
    t(this, "name", "availabilityChanged");
  }
}
class Q extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsEnabled");
  }
}
class Z extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsDisabled");
  }
}
class ee extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsDeleted");
  }
}
class ne extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsAppliedToInbox");
  }
}
class te extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicsReviewNotificationClicked");
  }
}
class se extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUserCreated");
  }
}
class ae extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUserModified");
  }
}
class oe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicConvoOverride");
  }
}
class ie extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicValueEnabled");
  }
}
class de extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicValueDisabled");
  }
}
class le extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedSearch");
  }
}
class ce extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedReports");
  }
}
class re extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedWorkflows");
  }
}
class ue extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedViews");
  }
}
class me extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "topicUsedColumns");
  }
}
class pe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedColumns");
  }
}
class ve extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentRemovedFromColumns");
  }
}
class Ce extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "sentimentUsedViews");
  }
}
class xe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "docsArticleCreated");
  }
}
class Ee extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "docsAiAnswersPromoClicked");
  }
}
class u extends s {
  constructor(n) {
    if (!n.inboxForwarderContext && typeof window < "u") {
      const o = window.location.pathname.includes("/settings/inbox");
      super({
        ...n,
        inboxForwarderContext: o ? "inbox-settings" : "setup-guide"
      });
    } else
      super(n);
  }
}
class we extends u {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderCancelClicked");
  }
}
class Se extends u {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderConnectChannelsClicked");
  }
}
class Ae extends u {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderConnectDifferentEmailClicked");
  }
}
class ge extends u {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxForwarderFinishLaterClicked");
  }
}
class fe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companySidebarToggled");
  }
}
class ye extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyListOpened");
  }
}
class ke extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyProfileOpened");
  }
}
class be extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyProfileTabOpened");
  }
}
class he extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companySidepanelOpened");
  }
}
class Te extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyProfileEditSaved");
  }
}
class Ie extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyPropertiesUpsellClicked");
  }
}
class Pe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "companyOverviewTimeframeChanged");
  }
}
class Re extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "contactProfileTabOpened");
  }
}
class Oe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementAdded");
  }
}
class _e extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementUpdated");
  }
}
class Me extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementDeleted");
  }
}
class De extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improveButtonClicked");
  }
}
class Ve extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "improvementGenerated");
  }
}
class g extends s {
}
class Fe extends g {
  constructor() {
    super(...arguments);
    t(this, "name", 'In App Tour "Next" Button Clicked');
  }
}
class Be extends g {
  constructor() {
    super(...arguments);
    t(this, "name", 'In App Tour "Close" Button Clicked');
  }
}
class Ue extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxBlankSlateClicked");
  }
}
class Ge extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxConnectBannerClicked");
  }
}
class Le extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxWelcomeModalClicked");
  }
}
class We extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideStepViewed");
  }
}
class Ne extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideStepCtaClicked");
  }
}
class Ke extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideHelpLinkClicked");
  }
}
class Ye extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideDismissed");
  }
}
class $e extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "setupGuideRestored");
  }
}
class f extends s {
}
class He extends f {
  constructor() {
    super(...arguments);
    t(this, "name", "viewClosedConversationsIncluded");
  }
}
class je extends f {
  constructor() {
    super(...arguments);
    t(this, "name", "viewClosedConversationsExcluded");
  }
}
class v extends s {
}
class C extends s {
}
class Je extends v {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsMenuOpened");
  }
}
class ze extends v {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsAddMenuOpened");
  }
}
class Xe extends v {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsReset");
  }
}
class qe extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsReordered");
  }
}
class Qe extends C {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnAdded");
  }
}
class Ze extends C {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnRemoved");
  }
}
class en extends C {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnHeaderClicked");
  }
}
class nn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewSorted");
  }
}
class tn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalOpened");
  }
}
class sn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalClosed");
  }
}
class an extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalSelectAllClicked");
  }
}
class on extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopyModalClearAllClicked");
  }
}
class dn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "viewColumnsCopied");
  }
}
class ln extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAnswersEnabled");
  }
}
class cn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAnswersDisabled");
  }
}
class rn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxAiAnswersEnabled");
  }
}
class un extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inboxAiAnswersDisabled");
  }
}
class mn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "prepaidAiAnswersContactUsClicked");
  }
}
class pn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "prepaidAiAnswersManageClicked");
  }
}
class vn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "threadReactionAdded");
  }
}
class Cn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "threadReactionRemoved");
  }
}
class xn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "inAppBeaconMessageShown");
  }
}
class En extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconSetupStarted");
  }
}
class wn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconContactStepCompleted");
  }
}
class Sn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconCustomizeStepCompleted");
  }
}
class An extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconSelfServiceStepCompleted");
  }
}
class gn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "beaconSetupCompleted");
  }
}
class fn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentCreated");
  }
}
class yn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentDeleted");
  }
}
class kn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentPublished");
  }
}
class bn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentTestSessionStarted");
  }
}
class hn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentDocSourceAdded");
  }
}
class Tn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentDocSourceRemoved");
  }
}
class In extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentWebsiteSourceAdded");
  }
}
class Pn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentWebsiteSourceRemoved");
  }
}
class Rn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentNameChanged");
  }
}
class On extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentIdentityChanged");
  }
}
class _n extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentConnectionActivated");
  }
}
class Mn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupStepViewed");
  }
}
class Dn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupStepCompleted");
  }
}
class Vn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupCancelled");
  }
}
class Fn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupSourceAdded");
  }
}
class Bn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupSourceRemoved");
  }
}
class Un extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupCompleted");
  }
}
class Gn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupStarted");
  }
}
class Ln extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupNextClicked");
  }
}
class Wn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupBackClicked");
  }
}
class Nn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupTryItOutClicked");
  }
}
class Kn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAgentSetupAddKnowledgeClicked");
  }
}
class Yn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "aiAnswersSimulationStarted");
  }
}
class $n extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "globalBannerCtaClicked");
  }
}
class Hn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailGenerated");
  }
}
class jn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailAdded");
  }
}
class Jn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailUpdated");
  }
}
class zn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "guardrailDeleted");
  }
}
class Xn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "experienceKit");
  }
}
class qn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "roadblockFooterCtaClicked");
  }
}
class Qn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "roadblockCancellationBridgeLanded");
  }
}
class Zn extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "showOriginalClicked");
  }
}
class et extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalSettingsViewed");
  }
}
class nt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalSettingsSaved");
  }
}
class tt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalEnabled");
  }
}
class st extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "customerPortalDisabled");
  }
}
class at extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelConnectClicked");
  }
}
class ot extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelConnectionSubmitted");
  }
}
class it extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelConnectSetupCancelled");
  }
}
class dt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "channelDisconnectClicked");
  }
}
class lt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaOnboardingViewed");
  }
}
class ct extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaCreateStarted");
  }
}
class rt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaPolicyCreated");
  }
}
class ut extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaPolicyToggled");
  }
}
class mt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaPoliciesReordered");
  }
}
class pt extends s {
  constructor() {
    super(...arguments);
    t(this, "name", "slaLearnMoreClicked");
  }
}
const E = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccountDropdownItemClickedEvent: z,
  AccountDropdownOpenedEvent: J,
  AiAgentConnectionActivatedEvent: _n,
  AiAgentCreatedEvent: fn,
  AiAgentDeletedEvent: yn,
  AiAgentDocSourceAddedEvent: hn,
  AiAgentDocSourceRemovedEvent: Tn,
  AiAgentIdentityChangedEvent: On,
  AiAgentNameChangedEvent: Rn,
  AiAgentPublishedEvent: kn,
  AiAgentSetupAddKnowledgeClickedEvent: Kn,
  AiAgentSetupBackClickedEvent: Wn,
  AiAgentSetupCancelledEvent: Vn,
  AiAgentSetupCompletedEvent: Un,
  AiAgentSetupNextClickedEvent: Ln,
  AiAgentSetupSourceAddedEvent: Fn,
  AiAgentSetupSourceRemovedEvent: Bn,
  AiAgentSetupStartedEvent: Gn,
  AiAgentSetupStepCompletedEvent: Dn,
  AiAgentSetupStepViewedEvent: Mn,
  AiAgentSetupTryItOutClickedEvent: Nn,
  AiAgentTestSessionStartedEvent: bn,
  AiAgentWebsiteSourceAddedEvent: In,
  AiAgentWebsiteSourceRemovedEvent: Pn,
  AiAnswersDisabledEvent: cn,
  AiAnswersEnabledEvent: ln,
  AiAnswersSimulationStartedEvent: Yn,
  AvailabilityChangedEvent: q,
  AvailabilityToggleClickedEvent: X,
  BeaconContactStepCompletedEvent: wn,
  BeaconCustomizeStepCompletedEvent: Sn,
  BeaconSelfServiceStepCompletedEvent: An,
  BeaconSetupCompletedEvent: gn,
  BeaconSetupStartedEvent: En,
  ChannelConnectClickedEvent: at,
  ChannelConnectSetupCancelledEvent: it,
  ChannelConnectionSubmittedEvent: ot,
  ChannelDisconnectClickedEvent: dt,
  ClickedButtonEvent: $,
  ClickedLinkEvent: H,
  CompanyListOpenedEvent: ye,
  CompanyOverviewTimeframeChangedEvent: Pe,
  CompanyProfileEditSavedEvent: Te,
  CompanyProfileOpenedEvent: ke,
  CompanyProfileTabOpenedEvent: be,
  CompanyPropertiesUpsellClickedEvent: Ie,
  CompanySidebarToggledEvent: fe,
  CompanySidepanelOpenedEvent: he,
  ContactProfileTabOpenedEvent: Re,
  CustomerPortalDisabledEvent: st,
  CustomerPortalEnabledEvent: tt,
  CustomerPortalSettingsSavedEvent: nt,
  CustomerPortalSettingsViewedEvent: et,
  DocsAiAnswersPromoClickedEvent: Ee,
  DocsArticleCreatedEvent: xe,
  ExperienceKitEvent: Xn,
  GlobalBannerCtaClickedEvent: $n,
  GuardrailAddedEvent: jn,
  GuardrailDeletedEvent: zn,
  GuardrailGeneratedEvent: Hn,
  GuardrailUpdatedEvent: Jn,
  ImproveButtonClickedEvent: De,
  ImprovementAddedEvent: Oe,
  ImprovementDeletedEvent: Me,
  ImprovementGeneratedEvent: Ve,
  ImprovementUpdatedEvent: _e,
  InAppBeaconMessageShownEvent: xn,
  InAppTourCloseButtonClickedEvent: Be,
  InAppTourNextButtonClickedEvent: Fe,
  InboxAiAnswersDisabledEvent: un,
  InboxAiAnswersEnabledEvent: rn,
  InboxBlankSlateClickedEvent: Ue,
  InboxConnectBannerClickedEvent: Ge,
  InboxForwarderCancelClickedEvent: we,
  InboxForwarderConnectChannelsClickedEvent: Se,
  InboxForwarderConnectDifferentEmailClickedEvent: Ae,
  InboxForwarderFinishLaterClickedEvent: ge,
  InboxWelcomeModalClickedEvent: Le,
  PageVisitedEvent: Y,
  PrepaidAiAnswersContactUsClickedEvent: mn,
  PrepaidAiAnswersManageClickedEvent: pn,
  RoadblockCancellationBridgeLandedEvent: Qn,
  RoadblockFooterCtaClickedEvent: qn,
  SentimentRemovedFromColumnsEvent: ve,
  SentimentUsedColumnsEvent: pe,
  SentimentUsedViewsEvent: Ce,
  SetupGuideDismissed: Ye,
  SetupGuideHelpLinkClicked: Ke,
  SetupGuideRestored: $e,
  SetupGuideStepCtaClicked: Ne,
  SetupGuideStepViewed: We,
  ShowOriginalClickedEvent: Zn,
  SignedUpEvent: j,
  SlaCreateStartedEvent: ct,
  SlaLearnMoreClickedEvent: pt,
  SlaOnboardingViewedEvent: lt,
  SlaPoliciesReorderedEvent: mt,
  SlaPolicyCreatedEvent: rt,
  SlaPolicyToggledEvent: ut,
  ThreadReactionAddedEvent: vn,
  ThreadReactionRemovedEvent: Cn,
  TopicConvoOverrideEvent: oe,
  TopicUsedColumnsEvent: me,
  TopicUsedReportsEvent: ce,
  TopicUsedSearchEvent: le,
  TopicUsedViewsEvent: ue,
  TopicUsedWorkflowsEvent: re,
  TopicUserCreatedEvent: se,
  TopicUserModifiedEvent: ae,
  TopicValueDisabledEvent: de,
  TopicValueEnabledEvent: ie,
  TopicsAppliedToInboxEvent: ne,
  TopicsDeletedEvent: ee,
  TopicsDisabledEvent: Z,
  TopicsEnabledEvent: Q,
  TopicsReviewNotificationClickedEvent: te,
  ViewClosedConversationsExcludedEvent: je,
  ViewClosedConversationsIncludedEvent: He,
  ViewColumnAddedEvent: Qe,
  ViewColumnHeaderClickedEvent: en,
  ViewColumnRemovedEvent: Ze,
  ViewColumnSortedEvent: nn,
  ViewColumnsAddMenuOpenedEvent: ze,
  ViewColumnsCopiedEvent: dn,
  ViewColumnsCopyModalClearAllClickedEvent: on,
  ViewColumnsCopyModalClosedEvent: sn,
  ViewColumnsCopyModalOpenedEvent: tn,
  ViewColumnsCopyModalSelectAllClickedEvent: an,
  ViewColumnsMenuOpenedEvent: Je,
  ViewColumnsReorderedEvent: qe,
  ViewColumnsResetEvent: Xe
}, Symbol.toStringTag, { value: "Module" })), vt = (e) => {
  const n = e.replace(/Event$/, "");
  return n.length === 0 ? "" : n.charAt(0).toLowerCase() + n.slice(1);
}, Ct = () => {
  const e = {};
  return new Proxy(e, {
    get: (n, a) => {
      const o = Object.keys(E).find(
        (d) => vt(d) === a
      );
      if (!o)
        throw new Error(`No event found for method: ${String(a)}`);
      const i = E[o];
      return (d = {}) => new i(d).track();
    }
  });
}, yt = Ct();
export {
  wt as ensureMixpanelFlagsReady,
  Et as getDistinctId,
  St as getMixpanelFlagSync,
  W as getMixpanelVariantValueSync,
  gt as identify,
  At as isMixpanelFlagEnabled,
  ft as resetIdentity,
  yt as track
};
